import { Accordion, AccordionDetails, AccordionSummary, Divider } from "@mui/material";
import React from "react";
import UserInfoActions from "../../../components/UserInfoCard/UserInfoActions";
import { MainButton, OutlinedButton } from "../../../components/UserInfoCard/style";
import WrapperCard from "../../../components/WrapperCard";
import { FaChevronDown } from "react-icons/fa";
import UserAvatar from "../../../components/UserInfoCard/UserAvatar";
import { useAuth } from "../../../hooks/auth";
import { getUserInfoNoDataStyles } from "./styles";
import { getDashboardCardProps } from "../theme/dashboardTheme";

const EMAIL_ADDRESS = "contato@7cantos.com";
const EMAIL_SUBJECT = "Tenho uma reclamação da 7cantos.";

function UserInfoNoData({smDown, lgDown = false, ...props}:any) {
    const { user } = useAuth();
    const ownerFirstName = user?.first_name ?? 'Proprietário';
    const s = getUserInfoNoDataStyles(lgDown);
    const children = (
        <>
          <Divider style={s.divider} />
          <UserInfoActions>
            <MainButton
              href="https://api.whatsapp.com/send/?phone=551140037654&text&type=phone_number&app_absent=0"
              color="primary"
              style={s.buttonMain}
            >
              Suporte 7Cantos
            </MainButton>
            <OutlinedButton
              href={`mailto:${EMAIL_ADDRESS}?subject=${encodeURIComponent(
                EMAIL_SUBJECT
              )}`}
              color="dark"
              style={s.buttonOutlined}
            >
              Reclamações
            </OutlinedButton>
          </UserInfoActions>
        </>
      );
    
      return (
        <WrapperCard {...getDashboardCardProps()} {...props}>
          {smDown && (
            <Accordion
              style={{
                boxShadow: "none",
                background: "transparent",
                color: "inherit",
              }}
            >
              <AccordionSummary expandIcon={<FaChevronDown fontSize="14px" />}>
                <h5 style={s.accordionTitle}>
                  Bem-vindo(a), {ownerFirstName}!
                </h5>
              </AccordionSummary>
              <AccordionDetails
                style={{ display: "flex", flexDirection: "column" }}
              >
                {children}
              </AccordionDetails>
            </Accordion>
          )}
          {!smDown && (
            <>
              <UserAvatar name={ownerFirstName} isTenant={false} />
              {children}
            </>
          )}
        </WrapperCard>
      );
}

export default UserInfoNoData;